export const itemsNameList = ["Featured Items", "Newsletters", "Notifications", "Blogs"];
export const listOfYears: number[] = [2024, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035]

export const customNavData = [
    { id: 1, icon: "user", title: "Personal info" },
    { id: 2, icon: "link-slash", title: "Connect bank account" },
    { id: 3, icon: "users", title: "Inquiries" },
    { id: 4, icon: "users", title: "Completed " },
];

export const popularBanksList = [
    { image: "hdfc.png", bankName: "ABC BANK" },
    { image: "Bank-of-Baroda.png", bankName: "XYZ BANK" },
    { image: "idbi.png", bankName: "PQR BANK" },
    { image: "rbl.png", bankName: "DEF BANK" },
    { image: "us-bank.png", bankName: "MNO BANK" },
    { image: "axis.png", bankName: "WXY BANK" },
    { image: "SCB.png", bankName: "STD BANK" },
];

export const businessNavData = [
    { id: 1, title: "Client 1 Details" },
    { id: 2, title: "Client 2 Details" },
    { id: 3, title: "Dependents" },
    { id: 4, title: "Assets - Property" },
    { id: 5, title: "Assets - Non-Property" },
    { id: 6, title: "Assets - Vehicles" }, 
    { id: 7, title: "Liabilities" },
    { id: 8, title: "Expenses" },
];

export const selectAccountTypeData = [
    { icon: "building-columns", title: "Business" },
    { icon: "user", title: "Personal " },
];

export const variationBoxData = [
    { title: "Tivo", details: "2-3 Members" },
    { title: "Admiro", details: "4-5 Members" },
    { title: "Multikart", details: "2 Member" },
    { title: "Roxo", details: "1 Member" },
];

//two-factor
export const modalOneData = [
    {
        icon: "gear",
        title: "2FA Authenticator",
        description: "Obtain codes from a authy/google authenticator/ios 15 etc.",
    },
    {
        icon: "comment",
        title: "SMS",
        description: "The backup login method will be sent to you via SMS if you require it.",
    }
];
export const numberingWizardSubTitle = [
    { text: "This is a validation form." },
];

export const studentValidationFormSubTitle = [
    { text: "Please make sure fill all the filed before click on next button." },
];
export const verticalValidationWizardSubTitle = [
    { text: "Fill up your true details and next proceed." },
];
export const shippingFormSubTitle = [
    { text: "Fill up your true details and next proceed." },
];

export const stepperHorizontalData = [
    {
        class: "one stepper",
        text: "Basic Info"
    },
    {
        text: "Cart Info",
        class: "two"
    },
    {
        text: "Feedback",
        class: "three"
    },
    {
        text: "Finish",
        class: "four"
    }
];
export const paymentModeName = ["Visa", "MasterCard", "paypal"];

export const verticalWizardNav = [
    {
        id: 1,
        icon: 'user',
        title: 'Your Info',
        subTitle: 'Add your details',
    },
    {
        id: 2,
        icon: 'link-slash',
        title: 'Cart Info',
        subTitle: 'Add your a/c details',
    },
    {
        id: 3,
        icon: 'users',
        title: 'Net Banking',
        subTitle: 'Choose your bank',
    },
];

export const netBankingFormBankList = [
    { bankList: ["Industrial & Commercial Bank", "Agricultural Bank", "JPMorgan Chase & Co."] },
    { bankList: ["Construction Bank Corp.", "Bank of America", "HDFC Bank"] },
]

export const shippingFormNav = [
    {
        id: 1,
        icon: "user",
        title: "Our Fees",
    },
    {
        id: 2,
        icon: "truck",
        title: "Shipping",
    },
    {
        id: 3,
        icon: "money-bill",
        title: "Payment",
    },
    {
        id: 4,
        icon: "square-check",
        title: "Finish",
    },
];

export const countryData = ['Select Country', 'Africa', 'India', 'Indonesia', 'Netherlands', 'U.K', 'U.S'];

export const homeAndOfficeAddressData = [
    {
        value: "shipping-choose1",
        label: "Home",
        name: "Filomena Green ",
        adress: "2211 Fruitville Rd, Sarasota, Florida, US 34237",
        contact: "(941) 321-5643",
    },
    {
        value: "shipping-choose2",
        label: "Work",
        name: "Ms. Ila Runte DDS",
        adress: " 1531 E 23rd St S, Independence, Mississippi, US 64055",
        contact: "(816) 252-4500",
        check: 'checked'
    },
];

export const shippingMethodsData = [
    {
        value: "standardDelivery",
        label: "Standard Delivery - Free",
        details: "Estimated 5-7 days shipping",
    },
    {
        value: "expressDelivery",
        label: "Express Delivery - $24",
        details: "Estimated 1-2 days shipping",
        check: 'checked'
    },
];

export const currentCartTableFooterData = [
    { footerTittle: "Sub Total :", price: "1284.00" },
    { footerTittle: "Discount :", price: "20.00" },
    { footerTittle: "Shipping Charge :", price: "100.78" },
    { footerTittle: "Tax :", price: "205.34" },
    { footerTittle: "Total (USD) :", price: "1569.7" },
];

export const currentCartTableBodyData = [
    {
        imagePath: "product/13.png",
        productName: "T-shirt",
        productSum: "$98 * 2",
        price: "$400",
    },
    {
        imagePath: "product-1/2.png",
        productName: "Headphone",
        productSum: "$4*2",
        price: "$450",
    },
    {
        imagePath: "product/2.png",
        productName: "T-shirt ",
        productSum: "$10*2",
        price: "$234",
    },
    {
        imagePath: "product-1/4.png",
        productName: "Chairs ",
        productSum: "$98*2",
        price: "$200",
    },
];
